import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import moment from 'moment';

import config from '../../config';
import Loading from '../../common/components/Loading';
import Icon from '../../common/icons/Icon';
import Badge from '../../common/badge/Badge';
import getDecodedToken from '../../common/auth/utils/getDecodedToken';

import ProfileTextField from './components/ProfileTextField';
import ProfileDateField from './components/ProfileDateField';
import ProfileSelectField from './components/ProfileSelectField';
import ProfileHistoryField from './components/ProfileHistoryField';

import {
  updateUser,
  updateUserHandicap,
  updateUserScore,
  updateUserDrivingDistance,
  updateUser7ironDistance,
  getProfileData,
} from './redux/actions';

import { NAME_VALIDATIONS, GENDER_OPTIONS, COURSE_VALIDATIONS } from './profile-constants';

class Profile extends Component {
  state = {
    showHistory: null,
  };

  componentDidMount() {
    const userId = getDecodedToken().sub;
    this.props.dispatch(getProfileData(userId));
  }

  toggleShowHistory = name => () => {
    const { showHistory } = this.state;
    if (!showHistory || showHistory !== name) {
      this.setState({
        showHistory: name,
      });
    } else {
      this.setState({
        showHistory: null,
      });
    }
  };

  handleChangeEmail = () => {
    window.location.href = [
      config.auth.domain,
      '/user/email-settings?client_id=',
      config.auth.clientId,
      '&redirect_uri=',
      config.auth.redirectUri,
    ].join('');
  };

  renderLeftContainer = () => {
    return (
      <div className="profile__profile-pic--wrapper" name="left-container">
        <img src="https://d27vybgvtr1dba.cloudfront.net/default_profile_img.png" alt="Account Settings Dropdown" />
      </div>
    );
  };

  renderRightContainer = () => {
    const { user, dispatch } = this.props;
    const { showHistory } = this.state;
    const userID = user.get('id');

    return (
      <div className="profile__fields-container" name="right-container">
        <div className="personal-info">
          <h3>Personal Information</h3>
          <div className="profile__input--wrapper">
            <h4>Name</h4>
            <div className="profile__input">
              <ProfileTextField
                fieldData={user.get('name')}
                validations={NAME_VALIDATIONS}
                action={name => dispatch(updateUser(userID, { name }))}
                editable
              />
            </div>
          </div>
          <div className="profile__input--wrapper">
            <h4>Email</h4>
            <div className="profile__input">
              <div className="profile-base-field">
                <div className="profile-text-field">
                  <span>{user.getIn(['oidc_user', 'email'])}</span>
                  <button className="profile-text-field__edit-button" type="button" onClick={this.handleChangeEmail}>
                    <Icon icon="Pencil" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="profile__input--wrapper">
            <h4>Date of Birth</h4>
            <div className="profile__input">
              <ProfileDateField
                fieldData={user.get('birthday') ? moment.utc(user.get('birthday')).format('MM/DD/YYYY') : ''}
                placeHolder="Not Set"
                action={birthday => {
                  dispatch(updateUser(userID, { birthday }));
                }}
                editable
              />
            </div>
          </div>
          <div className="profile__input--wrapper">
            <h4>Gender</h4>
            <div className="profile__input">
              <ProfileSelectField
                fieldData={user.get('gender')}
                placeHolder="Not Set"
                options={GENDER_OPTIONS}
                action={gender => dispatch(updateUser(userID, { gender }))}
                editable
              />
            </div>
          </div>
        </div>

        <div className="personal-stats">
          <h3>Personal Stats</h3>
          <div className="profile__input--wrapper">
            <h4>Home Course</h4>
            <div className="profile__input">
              <ProfileTextField
                fieldData={user.get('course')}
                placeHolder="Not Set"
                validations={COURSE_VALIDATIONS}
                action={course => dispatch(updateUser(userID, { course }))}
                editable
              />
            </div>
          </div>
          <div className="profile__input--wrapper">
            <h4>Handicap</h4>
            <div className="profile__input">
              <ProfileHistoryField
                title="Handicap"
                fieldData={user.get('handicaps')}
                placeHolder="Not Set"
                action={handicap => dispatch(updateUserHandicap(userID, handicap))}
                propertyName="handicap"
                showHistory={showHistory === 'handicap'}
                toggleShowHistory={this.toggleShowHistory('handicap')}
                inputRegex={/[^-0-9.]+/g}
                editable
              />
            </div>
          </div>
          <div className="profile__input--wrapper">
            <h4>Best Score</h4>
            <div className="profile__input">
              <ProfileHistoryField
                title="Best Score"
                fieldData={user.get('scores')}
                placeHolder="Not Set"
                action={score => dispatch(updateUserScore(userID, score))}
                propertyName="score"
                showHistory={showHistory === 'score'}
                toggleShowHistory={this.toggleShowHistory('score')}
                inputRegex={/[^-0-9]+/g}
                editable
              />
            </div>
          </div>
          <div className="profile__input--wrapper">
            <h4>Driving Distance</h4>
            <div className="profile__input">
              <ProfileHistoryField
                title="Driving Distance"
                fieldData={user.get('drivingDistances')}
                placeHolder="Not Set"
                action={score => dispatch(updateUserDrivingDistance(userID, score))}
                propertyName="distance"
                showHistory={showHistory === 'drivingDistances'}
                toggleShowHistory={this.toggleShowHistory('drivingDistances')}
                inputRegex={/[^0-9]+/g}
                editable
              />
            </div>
          </div>
          <div className="profile__input--wrapper">
            <h4>7-Iron Distance</h4>
            <div className="profile__input">
              <ProfileHistoryField
                title="7-Iron Distance"
                fieldData={user.get('sevenIronDistances')}
                placeHolder="Not Set"
                action={score => dispatch(updateUser7ironDistance(userID, score))}
                propertyName="distance"
                showHistory={showHistory === 'sevenIronDistances'}
                toggleShowHistory={this.toggleShowHistory('sevenIronDistances')}
                inputRegex={/[^0-9]+/g}
                editable
              />
            </div>
          </div>
        </div>
        {this.renderBadges()}
      </div>
    );
  };

  renderBadges = () => {
    const { user } = this.props;
    const badges = user.get('badges');

    return (
      <div className="profile__badges--wrapper">
        <h2>Badges</h2>
        <div className="badges-container">
          {badges && badges.size > 0 ? (
            badges.map((badge, index) => {
              return <Badge key={`badge-${index}`} badge={badge} />;
            })
          ) : (
            <h4>You do not have any badges</h4>
          )}
        </div>
      </div>
    );
  };

  render = () => {
    const { loading } = this.props;

    if (loading) return <Loading />;

    return (
      <div className="profile container">
        <Helmet>
          <title>Tathata Golf - Profile</title>
        </Helmet>
        <h2 className="profile__header">My Profile</h2>
        <div className="profile__columns-wrapper">
          {this.renderLeftContainer()}
          {this.renderRightContainer()}
        </div>
      </div>
    );
  };
}

const mapStateToProps = state => {
  return {
    user: state.subscription.user.get('data'),
    loading: state.subscription.profileData.get('loading'),
  };
};

export default connect(mapStateToProps)(Profile);



// WEBPACK FOOTER //
// ./src/subscription/profile/Profile.js